<template>
    <div>
        <el-card shadow='never' class='box-card'>
            <div v-if='tipMessage' slot='header' class='clearfix'>
                <el-alert
                    :title='tipMessage'
                    type='success'
                    :closable='false'>
                </el-alert>
            </div>
            <el-row type='flex' :gutter='10' align='middle'>
                <el-col :span='1' v-if='selectedConditionList.length > 1'>
                    <div>
                        <span @click='handleChangeAndCondition'
                              class='class_condition'>{{ isAndOperator ? '且' : '或' }}</span>
                    </div>
                </el-col>
                <el-col :span='23'>
                    <div style='margin-top: 1rem;margin-bottom: 1rem;' ref='conditionList'
                         v-for='(item, index) in selectedConditionList' :key='index'>
                        <el-row :gutter='2'>
                            <el-col :span='21'>
                                <el-row :gutter='10'>
                                    <el-col :span='6'>
                                        <el-select @change='chooseConditionField($event, item)'
                                                   size='mini'
                                                   filterable
                                                   v-model='item.selectFieldName' placeholder='请选择字段'>
                                            <el-option
                                                v-for='item in dimensionOption'
                                                :key='item.value'
                                                :label='item.label'
                                                :disabled='item.disabled'
                                                :value='item.value'>
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span='6'>
                                        <el-select @change='handleChangeOperator($event, item)'
                                                   v-model='item.operator'
                                                   size='mini'
                                                   placeholder='请选择'>
                                            <el-option
                                                v-for='option in item.operatorOption'
                                                :key='option.value'
                                                :label='option.label'
                                                :value='option.value'>
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span='12'>
                                        <div v-if='computeShowInputBox(item)'>
                                            <el-input @blur='packageConditionOperateList' :key='index' size='mini'
                                                      v-model='item.inputValue' />
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span='3'>
                                <el-row>
                                    <el-col :span='12'>
                                        <span @click='removeCondition(index)' class='el-icon-minus'
                                              style='cursor: pointer;height: 100%'></span>
                                    </el-col>
                                    <el-col :span='12'>
                                        <span @click='addCondition(index)' class='el-icon-plus'
                                              style='cursor: pointer;'></span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { deepCopy } from '@/utils/object';
import { trackParameterApi } from '@api/Track/trackParameter';
import { packageEventDimensionOption } from '@/utils/track/eventInfo';

export default defineComponent({
    name: 'TrackDataFilter',
    data() {
        return {
            typeOperationOption: {
                INTEGER: [
                    {
                        label: '大于',
                        value: '>'
                    },
                    {
                        label: '大于等于',
                        value: '>='
                    },
                    {
                        label: '小于',
                        value: '<'
                    },
                    {
                        label: '小于等于',
                        value: '<='
                    },
                    {
                        label: '等于',
                        value: '=='
                    }
                ],
                STRING: [
                    {
                        label: '等于',
                        value: '=='
                    },
                    {
                        label: '不等于',
                        value: '!='
                    },
                    {
                        label: '为空',
                        value: 'isEmpty',
                        showInputBox: false
                    },
                    {
                        label: '不为空',
                        value: 'isNotEmpty',
                        showInputBox: false
                    },
                    {
                        label: '开头是',
                        value: 'startWith'
                    },
                    {
                        label: '结尾是',
                        value: 'endsWith'
                    },
                    {
                        label: '包含',
                        value: 'contains'
                    },
                    {
                        label: '不包含',
                        value: 'notContains'
                    }
                ]
            },
            dimensionOption: [],
            filterFieldOption: [],
            selectedConditionList: [],
            selectTempValue: undefined,
            eventParameterList: [],
            conditionOperateList: [],
            isAndOperator: true
        };
    },
    emits: ['getFilterCondition'],
    props: {
        tipMessage: {
            type: String
        },
        eventId: {
            type: String
        },
        conditionConfig: {
            type: Object
        }
    },
    created() {
        this.init();
    },
    watch: {
        eventId: {
            deep: true,
            handler(newVal) {
                this.init();
            }
        }
    },
    computed: {
        computeShowInputBox() {
            return (t) => {
                if (t.active) {
                    return t.active.showInputBox === undefined || t.active.showInputBox === true;
                } else {
                    return false;
                }
            };
        }
    },
    methods: {
        async queryEventParameters() {
            return trackParameterApi.queryTrackParameter({ eventId: this.eventId });
        },
        async init() {
            this.selectedConditionList = [];
            if (!this.eventId) {
                return;
            }
            this.eventParameterList = [];
            this.filterFieldOption = [];
            let result = await this.queryEventParameters();
            if (result && result.code === 200) {
                this.eventParameterList = result.data.result;
            }
            this.dimensionOption = await packageEventDimensionOption(this.eventParameterList);
            
            if (!this.conditionConfig || !this.conditionConfig.conditionList || this.conditionConfig.conditionList.length === 0) {
                this.selectedConditionList.push({});
            } else {
                this.conditionConfig.conditionList = this.conditionConfig.conditionList.filter(t => t.variable && t.operator);
                if (this.conditionConfig.conditionList.length === 0) {
                    this.selectedConditionList.push({});
                    return;
                }
                this.isAndOperator = this.conditionConfig.andOperator;
                this.conditionConfig.conditionList.forEach((condition, conditionIndex) => {
                    let data = {};
                    data.selectFieldName = condition.variable;
                    data.inputValue = condition.operand;
                    data.operator = condition.operator;
                    this.dimensionOption.forEach((option, optionIndex) => {
                        if (option.value === data.selectFieldName) {
                            data.parameter = option;
                            data.operatorOption = deepCopy(this.typeOperationOption[option.parameterType]);
                            data.operatorOption.forEach((f, index) => {
                                if (f.value === data.operator) {
                                    data.active = f;
                                    this.selectedConditionList.push(data);
                                }
                            });
                        }
                    });
                });
            }
        },
        handleCleanAll() {
            this.selectedConditionMap.clear();
        },
        chooseConditionField(fieldName, item) {
            this.dimensionOption.forEach((t) => {
                if (t.value === fieldName) {
                    item.parameter = t;
                    item.operatorOption = deepCopy(this.typeOperationOption[t.parameterType]);
                }
            });
            this.packageConditionOperateList();
        },
        addCondition() {
            this.selectedConditionList.push({});
            this.packageConditionOperateList();
        },
        removeCondition(index) {
            if (this.selectedConditionList.length === 1) {
                this.selectedConditionList.splice(index, 1);
                this.selectedConditionList.push({});
            } else {
                this.selectedConditionList.splice(index, 1);
            }
            this.packageConditionOperateList();
        },
        handleChangeOperator(key, item) {
            item['operatorOption'].forEach(t => {
                if (t.value === key) {
                    item.active = t;
                }
            });
            this.packageConditionOperateList();
        },
        packageConditionOperateList() {
            this.conditionOperateList = [];
            this.selectedConditionList.forEach((item, index) => {
                if (!item.selectFieldName || !item.operator) {
                    if (index === this.selectedConditionList.length - 1) {
                        this.submitCondition();
                    }
                    return;
                }
                
                let inputValue = item.inputValue;
                if (item.active.showInputBox === undefined || item.active.showInputBox === true) {
                    if (!inputValue) {
                        if (index === this.selectedConditionList.length - 1) {
                            this.submitCondition();
                        }
                        return;
                    }
                }
                
                if (item.active.showInputBox === false) {
                    inputValue = undefined;
                }
                
                let operand;
                if (item.parameter.parameterType === 'STRING' && inputValue) {
                    if (inputValue.startsWith('\'') && inputValue.endsWith('\'')) {
                        operand = inputValue;
                    } else {
                        operand = `'${inputValue}'`;
                    }
                } else {
                    operand = inputValue;
                }
                
                this.conditionOperateList.push({
                    variable: item.selectFieldName,
                    operand: operand,
                    operator: item.operator
                });
                if (index === this.selectedConditionList.length - 1) {
                    this.submitCondition();
                }
            });
        },
        handleChangeAndCondition() {
            this.isAndOperator = !this.isAndOperator;
            this.packageConditionOperateList();
        },
        submitCondition() {
            let condition = {
                andOperator: this.isAndOperator,
                conditionList: this.conditionOperateList
            };
            this.$emit('getFilterCondition', condition);
        }
    }
});
</script>

<style scoped lang='css'>
.class_condition {
    background-color: #409EFF;
    cursor: pointer;
    padding: 5px;
    border-radius: 5px;
    color: white;
}
</style>
